import { FC, useContext } from "react";

import { Logo } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Paragraph } from "capitalrx-components-2.0/lib/typography";

import { ThemeSelectorContext } from "@/context";
import judiHealth from "@/static/logos/judi-health-horizontal.png";

import styles from "./Footer.module.scss";

export const Footer: FC = () => {
  const { clientDisplayName } = useContext(ThemeSelectorContext);
  const showFooter = clientDisplayName === "Judi Health";

  return (
    <>
      {showFooter && (
        <Stack alignment="center" className={styles.FooterContainer}>
          <Shelf spacing="small" style={{ alignItems: "center" }}>
            <img src={judiHealth} style={{ height: "24px", width: "135px" }} />
            <span
              aria-hidden="true"
              style={{
                display: "inline-block",
                width: "1px",
                height: "17.53px",
                backgroundColor: "#80B8D9",
                opacity: 1,
                margin: "0 8px",
              }}
            />
            <Logo name="caprx-horizontal" style={{ height: "24px", width: "105px" }} />
          </Shelf>
          <Paragraph>
            <Body>® 2025 Capital Rx, Inc. All Rights Reserved.</Body>
          </Paragraph>
        </Stack>
      )}
    </>
  );
};
